import React from 'react';
import { Quote, Star } from 'lucide-react';

const TESTIMONIALS = [
  {
    q: "Motor iNKS is our default install partner in TX. They ship white-label, keep our margins clean, and hit every deadline.",
    a: 'Nikki R.',
    r: 'Print Shop Owner · Dallas, TX',
  },
  {
    q: "We had a 12-van fleet to wrap in a weekend. They ran two teams, delivered Sunday night. Zero seams, zero drama.",
    a: 'Marcus D.',
    r: 'Ops Manager · HVAC Fleet',
  },
  {
    q: "The Wrapulator alone saved us hours. Add the actual install crew and it's a one-stop shop.",
    a: 'Alicia K.',
    r: 'Sign Company GM',
  },
];

const CERTS = ['3M PREFERRED INSTALLER', 'AVERY CERTIFIED', 'ORAFOL AUTHORIZED', 'PPF TRAINED', 'FLEET COMPLIANT'];

export default function Testimonials() {
  return (
    <section className="relative py-24 lg:py-28 border-b mi-line">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="mi-eyebrow mb-3">// FROM OUR B2B PARTNERS</div>
        <h2 className="mi-headline text-4xl md:text-5xl lg:text-6xl mb-12">
          The people who put us <span className="text-[#E63946]">on the truck.</span>
        </h2>

        <div className="grid md:grid-cols-3 gap-4 mb-12">
          {TESTIMONIALS.map((t, i) => (
            <div key={i} className="mi-surface p-6 lg:p-8">
              <Quote className="w-6 h-6 text-[#E63946] mb-4" />
              <p className="text-white/85 leading-relaxed mb-6">"{t.q}"</p>
              <div className="mi-sep mb-4" />
              <div className="flex items-center justify-between">
                <div>
                  <div className="mi-headline text-lg">{t.a}</div>
                  <div className="mi-eyebrow mt-1 text-white/60">{t.r}</div>
                </div>
                <div className="flex text-[#E63946]">
                  {Array.from({ length: 5 }).map((_, k) => <Star key={k} className="w-3.5 h-3.5 fill-current" />)}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="border-t mi-line-strong pt-6 flex flex-wrap items-center gap-x-8 gap-y-3">
          <span className="mi-eyebrow text-white/40">CERTIFIED :</span>
          {CERTS.map((c) => (
            <span key={c} className="mi-eyebrow text-white/80">{c}</span>
          ))}
        </div>
      </div>
    </section>
  );
}
